import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { DavidC_Video1 } from '../../../../../utils/EN/Modals/aiArtists';

const ModalVideoDavidC1 = () => {
  return (
    <>
      <ModalVideo
        id="david-video-1"
        dataText={DavidC_Video1}
        videoSrc="https://www.youtube.com/embed/R2nreWySYkY?si=-X-bx3joxVYAlGNu"
        videoTitle="KUTER_STUDIO_AI_DAVID_C_VIDEO_1"
      />
    </>
  );
};

export default ModalVideoDavidC1;
